import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {MdDateRange} from "react-icons/md";
import {withStyles} from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import twLocale from "date-fns/locale/zh-TW";
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import utils from "../../../utils";

const Container = styled.div`
  position: relative;
  cursor: pointer;
`;

const DateIcon = styled(MdDateRange)`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  cursor: pointer;
`

const styles = () => ({
    root: {
        width: "100%",
    }
});

function DateTimeField({value, onChange}) {
    const locale = twLocale;

    return <Container>
        <DateIcon />
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <DateTimePicker
                format="yyyy-MM-dd HH:mm"
                value={utils.toTaipeiTimeWithZoneIdStr(value)}
                onChange={value=> onChange(utils.toTaipeiTimeWithZoneIdStr(value))}
                showTodayButton={true}
                okLabel="確定"
                cancelLabel="取消"
                todayLabel="今天"
            />
        </MuiPickersUtilsProvider>
    </Container>
}

DateTimeField.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func
};

export default withStyles(styles)(DateTimeField);
